import { CIcon } from '~/icons/types'

export const ciDeals: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.39 12.118A1.492 1.492 0 0 0 21 11.2h-3.01V2.97A1.487 1.487 0 0 0 16.5 1.5H7.505a1.487 1.487 0 0 0-1.5 1.47v8.23H3a1.492 1.492 0 0 0-1.388.918 1.459 1.459 0 0 0 .361 1.622l9 8.358a1.519 1.519 0 0 0 2.06 0l9-8.357a1.46 1.46 0 0 0 .357-1.623Zm-1.04.89-9 8.357a.52.52 0 0 1-.7 0l-9-8.358a.454.454 0 0 1 .072-.727A.5.5 0 0 1 3 12.2h3.506a.5.5 0 0 0 .5-.5V2.97a.485.485 0 0 1 .5-.47H16.5a.485.485 0 0 1 .5.47v8.73a.5.5 0 0 0 .5.5H21a.5.5 0 0 1 .464.3.456.456 0 0 1-.114.508Z'
    },
    {
      d:
        'm14.653 7.64-6 5.76a.5.5 0 0 0 .694.722l6-5.76a.5.5 0 1 0-.694-.722ZM10.2 9.652a1.076 1.076 0 1 0-1.1-1.076 1.089 1.089 0 0 0 1.1 1.076Zm3.6 2.458a1.077 1.077 0 0 0-.177 2.132 1.076 1.076 0 0 0 1.277-1.057 1.089 1.089 0 0 0-1.1-1.076Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'deals',
  type: 'thin'
}
